import React from 'react';

import { DialogCloseButton, DialogTitle } from '@/ux-common/components/dialog/dialog';
import { Header, HeaderActions, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

interface DialogTitleHeaderProps {
  title: React.ReactNode;
}

/**
 * The standard registry Dialog header: the aria title styled as a section
 * header, with the close X as the only header action (UXD-31). For an
 * AlertDialog use AlertDialogTitleHeader — it has no close X by design.
 */
export const DialogTitleHeader = ({ title }: DialogTitleHeaderProps) => (
  <Header data-component="DialogTitleHeader">
    <HeaderTitle>
      <DialogTitle asChild>
        <Typography as="h2" className="text-header-section">
          {title}
        </Typography>
      </DialogTitle>
    </HeaderTitle>
    <HeaderActions>
      <DialogCloseButton />
    </HeaderActions>
  </Header>
);
